import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent } from 'angular-calendar';
import { addDays, addMonths, getDaysInMonth, isSameDay, isSameMonth } from 'date-fns';
import { Subject } from 'rxjs';
import { CalendarAdapter } from '../../../adapters/calendar.adapter';
import { User } from '../../../models';
import { ApiService, AuthService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { UscCalendarAdapter } from './usc-calendar-adapter';

@Component({
  selector: 'sn-usc-calendar-view',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './usc-calendar-view.component.html',
  styleUrls: ['../usc-store.component.css', './usc-calendar-view.component.css']
})

// https://angular-calendar.com/#/kitchen-sink
export class UscCalendarViewComponent implements OnInit {
    // view: CalendarView = CalendarView.Month;
    // CalendarView = CalendarView;
    view:string = "CalendarView.Month";
    adapter:CalendarAdapter;
    current_search_scope:string = "All Appointments";
    isStoreMgrOrAssistant:boolean = false;
    isCrossStoreScopeEnabled:boolean = true;

    modalData: {
        action: string;
        event: CalendarEvent;
    };

    actions: CalendarEventAction[] = [
        {
            label: '<i class="fas fa-fw fa-pencil-alt"></i>',
            // a11yLabel: 'Edit',
            onClick: ({ event }: { event: CalendarEvent }): void => {
                this.handleEvent('Edited', event);
            },
        },
        {
            label: '<i class="fas fa-fw fa-trash-alt"></i>',
            // a11yLabel: 'Delete',
            onClick: ({ event }: { event: CalendarEvent }): void => {
                this.events = this.events.filter((iEvent) => iEvent !== event);
                this.handleEvent('Deleted', event);
            },
        },
    ];

    events: CalendarEvent[] = [];
    refresh: Subject<any> = new Subject();
    activeDayIsOpen: boolean = true;
    viewDate: Date = new Date();

    constructor(
        public uscStoreService: UscStoreService,
        public apiService: ApiService,
        public authService: AuthService,
        private modal: NgbModal) {
        var teamScope = this.uscStoreService.isLeader();
        if (this.uscStoreService.isUSCellRetail() || this.uscStoreService.isUSCellTelesales()) teamScope = true;
        this.loadCalendarEvents(this.authService.getActive(), teamScope);
        var active_user = this.authService.getActive();
        var cross_access_enabled = this.uscStoreService.getItemCustomFieldValue(active_user, 'Cross-Store Calendar Access') == 'Yes';
        this.isCrossStoreScopeEnabled = this.uscStoreService.isUSCellCorp() && cross_access_enabled;        
    }

    public calendarUser: User;
    public loadCalendarEvents(user: User, teamScope:boolean) {
        this.calendarUser = user;
        this.adapter = new UscCalendarAdapter(user, teamScope, this.uscStoreService, this.apiService);
    }

    getDateOffset(direction:number) {
        var dateOffset = 0;
        if (this.view == this.adapter.Calendar_View_Month) {
            var month = addMonths(this.viewDate, 1 * direction);
            dateOffset = getDaysInMonth(month);
        } else if (this.view == this.adapter.Calendar_View_Week) {
            dateOffset = 7;
        } else {
            dateOffset = 1;
        }
        return dateOffset * direction;
    }

    ngOnInit() {
        this.loadEventData();
        this.isStoreMgrOrAssistant = this.uscStoreService.isStoreMgrOrAssistant();
        if (this.isStoreMgrOrAssistant) this.current_search_scope = "Team Appointments";
        this.uscStoreService.calendarEvents.subscribe(e => {
            if (e) this.loadEventData();
        });
    }

    bLoadingCalls: boolean = false;
    bLoadingMeetings: boolean = false;
    meetingEvents:CalendarEvent[];
    callEvents:CalendarEvent[];

    loadEventData() {
        this.events = this.adapter.getEvents({search_scope: this.current_search_scope});
        this.refresh.next(null);
    }

    onPrevious() {
        this.viewDate = addDays(this.viewDate, this.getDateOffset(-1));
    }

    onToday() {
        this.viewDate = new Date();
    }

    onNext() {
        this.viewDate = addDays(this.viewDate, this.getDateOffset(1));
    }

    dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
        if (isSameMonth(date, this.viewDate)) {
            if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
                this.activeDayIsOpen = false;
            } else {
                this.activeDayIsOpen = true;
            }
            this.viewDate = date;
        }
    }

    eventTimesChanged({event, newStart, newEnd, }: CalendarEventTimesChangedEvent): void {
        this.events = this.events.map((iEvent) => {
            if (iEvent === event) {
                return {
                ...event,
                start: newStart,
                end: newEnd,
                };
            }
            return iEvent;
        });
        this.handleEvent('Dropped or resized', event);
    }

    handleEvent(action: string, event: CalendarEvent): void {
        this.adapter.handleEvent(action, event);
    }

    addEvent(): void {
        // this.events = [
        //     ...this.events,
        //     {
        //         title: 'New event',
        //         start: startOfDay(new Date()),
        //         end: endOfDay(new Date()),
        //         color: this.Colors.red,
        //         draggable: true,
        //         resizable: {
        //             beforeStart: true,
        //             afterEnd: true,
        //         },
        //     },
        // ];
    }
    
    // deleteEvent(eventToDelete: CalendarEvent) {
    //     this.events = this.events.filter((event) => event !== eventToDelete);
    // }
    
    setView(view: string) {
        this.view = view;
    }

    getCalendarHeader() {
        return this.adapter.getCalendarTitle(this.view, this.viewDate);
    }

    getDateStartHour() {
        return this.adapter.getDateStartHour();
    }

    getDateEndHour() {
        return this.adapter.getDateEndHour();
    }

    showCalendarEvents(scope) {
        this.current_search_scope = scope;
        var teamScope = scope == "All Appointments";
        this.loadCalendarEvents(this.authService.getActive(), teamScope);
        this.loadEventData();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-calendar-view/usc-calendar-view.component.ts